import LTR from "@brand-icons/global/ui-cross-circle/ui-cross-circle-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiCrossCircleIcon = iconFactory("UiCrossCircleIcon", LTR);
